import { STAND } from 'app/constants'
import { Stand } from './types'
import { SOLANA_NETWORK } from './solana-config'

const SOLANA_RPC_URL = import.meta.env.VITE_SOLANA_RPC_URL as string | undefined

const SOLANA_EXPLORER_BASE = 'https://explorer.solana.com'

function getSolanaClusterParam(): string {
  if (SOLANA_RPC_URL) {
    return `?cluster=custom&customUrl=${encodeURIComponent(SOLANA_RPC_URL)}`
  }
  if (STAND === Stand.mainnet || SOLANA_NETWORK === 'mainnet-beta') {
    return ''
  }
  return '?cluster=devnet'
}

export function getExplorerBaseUrl(): string {
  return SOLANA_EXPLORER_BASE
}

export function getTxUrl(txHash: string): string {
  const param = getSolanaClusterParam()
  return `${SOLANA_EXPLORER_BASE}/tx/${txHash}${param}`
}

export function getAddressUrl(address: string): string {
  const param = getSolanaClusterParam()
  return `${SOLANA_EXPLORER_BASE}/address/${address}${param}`
}
